import { render, staticRenderFns } from "./Monsters.vue?vue&type=template&id=0642fa9a&scoped=true&"
import script from "./Monsters.vue?vue&type=script&lang=ts&"
export * from "./Monsters.vue?vue&type=script&lang=ts&"
import style0 from "./Monsters.vue?vue&type=style&index=0&id=0642fa9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642fa9a",
  null
  
)

export default component.exports